import { z } from 'zod';
import { timestamp } from './common.js';
/**
 * FTUE (F9) op DTOs. `users.ftueCompletedAt` (already on `userSchema`,
 * `packages/schemas/src/user.ts`) is read via the existing `settings.getProfile`
 * op (`settings.dto.ts` — WS-SETTINGS, already wired into `OP_TABLE`) — this
 * file only adds the one WRITE op this slice needs: marking the tour
 * complete. `ftue.complete` is idempotent (replaying it after completion is
 * a no-op that returns the already-set timestamp, never an error) so a
 * duplicate call from a flaky connection/replayed retry can't clobber a
 * later `ftueCompletedAt`.
 */
export const ftueCompleteResult = z.object({
    ftueCompletedAt: timestamp,
});
